enum JigsawEvent {
  TTS_STATUS = "tts-v2:status",
  USER_SIGNOUT = "user:signout",
  BOOK_CLICK = "book:click",
  PAGE_SCROLL = "page:scroll",
  PAGE_SCROLL_FULLSPEED = "page:scroll:fullspeed",
  TEXT_SELECTION = "book:selectionWithPosition",
  HIGHLIGHT_CLICK = "highlight:click",
  NOTE_ICON_CLICK = "noteicon:click",
  BOOK_NAV_REQUESTED = "book:navigationRequested",
  PAGE_RESIZE = "page:resize",
  PAGE_TRANSFORM = "page:transform",
  BOOK_SELECTION_MADE = "book:selectionMade",
  BOOK_SELECTION_CANCELLED = "book:selectionCancelled",
  PAGE_LOAD = "page:load",
  PAGE_BREAK = "book:pagebreak",
  PAGE_READY = "page:ready",
}

export default JigsawEvent;
